import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreRecentAgentConversationsSlice } from './get';

export const coreRecentAgentConversationsReducers = combineReducers({
	get: getCoreRecentAgentConversationsSlice.asyncReducers
});

export const coreRecentAgentConversationsWatchers = combineAllWatchers([
	getCoreRecentAgentConversationsSlice.asyncWatchers
]);
